'use client';

import clsx from 'clsx';
import s from './page.module.scss';
import { useTwoStepLeadForm } from '@publishing/hooks/useTwoStepLeadForm';
import { StepForm } from '@publishing/components/forms';
import { LEAD_FORM_NAME } from '@/features/lead-form/constants/formName';
import EventBubble from '@publishing/components/events/EventBubble';
import { getPublishingImage } from '@/shared/utils/publishingAsset';
import { FloatingConfig } from '@/shared/components/FloatingConfig';
import { FF } from '@/publishing/helpers';
export default function BestOfferPage() {
  const form = useTwoStepLeadForm();
  const { isStep2 } = form;

  return (
    <>
      <FloatingConfig
        zento={false}
        scrollTop={false}
      />
    <div className={clsx(s.bestoffer_contact, isStep2 && s.bestoffer_contact_is_step2)}>
      <section className={s.bestoffer_contact_hero}>
        <div className={s.bestoffer_contact_content}>
          <h1 className="blind">6개월 무료 사무실</h1>
          {!isStep2 && (
            <header className={s.bestoffer_contact_heading}>
              <EventBubble bgColor='#007FFF' textColor='--color-gray-100' textSize={14} className={s.bestoffer_contact_bubble}>사무실 매물만 {FF.OFFICE}개!</EventBubble>
              <h2 className={s.bestoffer_contact_title} aria-label="6개월 무료 사무실">
                <img src={getPublishingImage('contact/bestoffer/img_bestoffer_title.png')} width={410} height={86} alt="" />
              </h2>
              <p className={s.bestoffer_contact_notice}>극소량 매물 한정 주의</p>
            </header>
          )}

          <StepForm
            form={form}
            className={s.bestoffer_contact_card}
            classNameStep2={s.bestoffer_contact_card_step2}
            step2={{
              formName: LEAD_FORM_NAME.LOWEST_PRICE,
              submitLabel: '최저가 사무실 리스트 확인하기',
            }}
          />
        </div>
        </section>
      </div>
    </>
  );
}
